import { useEffect } from "react";

const SCRIPT_URL =
  "https://transfrvr1.my.site.com/ESWTechSupportMessaging1751911695622/assets/js/bootstrap.min.js";

const MIAW_CONFIG = {
  ORG_ID: "00D5e000000L1EY",
  DEVELOPER_NAME: "Tech_Support_Messaging",
  BASE_URL:
    "https://transfrvr1.my.site.com/ESWTechSupportMessaging1751911695622",
  SCRT2_URL: "https://transfrvr1.my.salesforce-scrt.com",
};

// The Salesforce SDK errors if bootstrap.init() runs more than once per page
// load. Module scope (not a per-instance ref) so the guard survives effect
// re-runs and remounts.
let bootstrapInitialized = false;

export const SupportChat = ({ user }) => {
  useEffect(() => {
    const handleMessagingReady = () => {
      const bootstrap = window.embeddedservice_bootstrap;

      bootstrap.prechatAPI.setVisiblePrechatFields({
        _firstName: { value: user.firstName || "", isEditableByEndUser: false },
        _lastName: { value: user.lastName || "", isEditableByEndUser: false },
        _email: { value: user.email || "", isEditableByEndUser: false },
      });

      bootstrap.prechatAPI.setHiddenPrechatFields({
        Originating_Site: window.location.href,
        Client_Code: user.organizationCode || "Unknown",
      });
    };

    const initMessaging = () => {
      if (bootstrapInitialized) return;
      bootstrapInitialized = true;

      try {
        const bootstrap = window.embeddedservice_bootstrap;
        bootstrap.settings.language = "en_US";
        bootstrap.settings.chatButtonPosition = "2rem,1.5rem";

        bootstrap.init(
          MIAW_CONFIG.ORG_ID,
          MIAW_CONFIG.DEVELOPER_NAME,
          MIAW_CONFIG.BASE_URL,
          { scrt2URL: MIAW_CONFIG.SCRT2_URL }
        );
      } catch (error) {
        bootstrapInitialized = false;
        console.error("Error initializing Embedded Messaging:", error);
      }
    };

    // Re-registered every effect run so the prechat fields track the latest user
    // even though init() runs only once.
    window.addEventListener("onEmbeddedMessagingReady", handleMessagingReady);

    if (window.embeddedservice_bootstrap) {
      initMessaging();
    } else {
      const s = document.createElement("script");
      s.setAttribute("src", SCRIPT_URL);
      s.async = true;
      s.addEventListener("load", () => {
        initMessaging();
      });
      document.body.append(s);
    }

    return () => {
      window.removeEventListener(
        "onEmbeddedMessagingReady",
        handleMessagingReady
      );

      const bootstrap = window.embeddedservice_bootstrap;

      // userVerificationAPI attaches only after init() completes, and the
      // component can unmount before that — guard on the API, not the global.
      if (bootstrap?.userVerificationAPI?.clearSession) {
        try {
          bootstrap.userVerificationAPI
            .clearSession(true)
            .then(() => {
              bootstrap.utilAPI?.removeAllComponents();
            })
            .catch((error) => console.warn("MIAW session clear failed:", error))
            .finally(() => {
              bootstrapInitialized = false;
            });
        } catch (error) {
          console.error("MIAW clearSession failed or not available:", error);
          bootstrapInitialized = false;
        }
      }
      // API not ready yet means init() is still in flight — leave the guard set.
    };
  }, [user.email, user.firstName, user.lastName]);

  return null;
};
